import RichText from "@/components/RichText";

// Repli tant que l'API n'a pas répondu (blocks === undefined) — même logique
// que ServicesSection/FaqSection : un aperçu plausible plutôt qu'un trou.
const FALLBACK_BLOCKS = [
  { id: "fallback-1", props: { quote: "Un accompagnement clair du premier appel à la livraison.", author: "Client", role: "" } },
  { id: "fallback-2", props: { quote: "Des délais tenus et un travail soigné.", author: "Cliente", role: "" } },
];

const DEFAULTS = { eyebrow: "", heading: "Ils nous ont fait confiance", subheading: "", variant: "light", anchor_id: "" };

export default function TestimonialsSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  // Une citation vide ne produit pas une carte vide : elle disparaît.
  const items = (blocks === undefined ? FALLBACK_BLOCKS : blocks).filter((b) => b.enabled !== false && b.props?.quote);
  if (!items.length) return null;

  const dark = t.variant === "dark";
  return (
    <section
      id={t.anchor_id || undefined}
      className={`${dark ? "bg-ink" : "bg-cream"} scroll-mt-28`}
    >
      <div className="max-w-[1240px] mx-auto px-6 md:px-10 pt-section-top md:pt-section-top-md pb-14">
        <div className="text-center">
          {t.eyebrow && (
            <RichText as="p" className="text-[13px] font-semibold tracking-wide text-gold uppercase mb-3" html={t.eyebrow} />
          )}
          <RichText
            as="h2"
            className={`font-display font-semibold text-[30px] md:text-[34px] leading-tight tracking-[-0.02em] ${dark ? "text-white" : "text-ink"}`}
            html={t.heading}
          />
          {t.subheading && (
            <RichText
              as="p"
              preserveParagraphs
              className={`text-[16px] mt-4 ${dark ? "text-white/70" : "text-graphite"}`}
              html={t.subheading}
            />
          )}
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {items.map((block) => (
            <figure
              key={block.id}
              data-block-key={block.id}
              className={`border-control rounded-xl p-6 flex flex-col gap-4 ${
                dark ? "border-white/15 bg-white/5" : "border-stone bg-white"
              }`}
            >
              <blockquote className={`text-[15px] leading-relaxed ${dark ? "text-white/85" : "text-graphite"}`}>
                {block.props.quote}
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3">
                {block.props.image_url && (
                  <img
                    src={block.props.image_url}
                    alt=""
                    loading="lazy"
                    className="h-10 w-10 rounded-full object-cover shrink-0"
                  />
                )}
                <span className="min-w-0">
                  <span className={`block text-[14px] font-semibold truncate ${dark ? "text-white" : "text-ink"}`}>
                    {block.props.author}
                  </span>
                  {block.props.role && (
                    <span className={`block text-[12px] truncate ${dark ? "text-white/60" : "text-ash"}`}>
                      {block.props.role}
                    </span>
                  )}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
